
<template>
  <v-container id="clientes" tag="section">
    <div id="contenedorPlantilla" hidden ref="contenedorPlantilla" />
    <base-v-component heading="Plantillas de contratos del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="primary" @click="addPlantilla"> Nueva plantilla </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="plantillas"
        :loading="loading"
        sort-by="fecha"
        sort-desc
      >
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="secondary"
                min-width="0"
                v-on="on"
                :loading="item.loadingPdf"
                small
                @click="verPdf(item)"
              >
                <v-icon small>mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Ver PDF</span>
          </v-tooltip>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                v-on="on"
                small
                @click="goEdit(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="red"
                min-width="0"
                v-on="on"
                :loading="item.loadingEliminar"
                small
                @click="goEliminar(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Borrar</span>
          </v-tooltip>-->
        </template>
      </v-data-table></base-material-card
    >
    <v-dialog v-model="formDialog" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                v-if="this.plantillaEditar.id"
                v-model="plantillaEditar.id"
                label="Id"
                disabled
              />
              <v-text-field v-model="plantillaEditar.nombre" label="Nombre" />
              <v-list dense>
                <v-list-item-title
                  >Variables dinámicas
                  <v-list-item-action class="ml-4">
                    <v-btn x-small @click="getVariables" class="secondary"
                      >Calcular Variables</v-btn
                    ></v-list-item-action
                  >
                </v-list-item-title>
                <v-list-item
                  dense
                  v-for="(item, i) in plantillaEditar.variables"
                  :key="i"
                >
                  {{ item }}
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="8" sm="6">
              <quill-editor
                :content="plantillaEditar.texto"
                class="mb-6"
                style="height: 200px"
                :options="editorOption"
                @change="onEditorChange($event)"
              ></quill-editor></v-col
          ></v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="formDialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="save" :loading="loadingForm"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";

import moment from "moment";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingEliminar: false,
      formDialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "text",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      plantillaEditar: {
        id: null,
        nombre: "",
        texto: "",
        variables: [],
      },
      editorOption: {
        placeholder: "Escribe aquí...",
        readOnly: false,
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      plantillasBruto: (state) => state.contratos.plantillas,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    formTitle() {
      return this.plantillaEditar.id ? "Editar Plantilla" : "Nueva Plantilla";
    },
    plantillas() {
      return this.plantillasBruto;
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
  },
  watch: {
    formDialog(val) {
      if (!val) this.reiniciarCampos();
    },
  },
  methods: {
    verPdf(item) {
      item.loadingPdf = true;
      item.loadingPdf = false;

      this.$store
        .dispatch("contratos/verPdfPlantilla", item)
        .then((r) => {
          console.log(r);
          window.open(r, "_blank");
        })
        .finally(() => {
          item.loadingPdf = false;
          console.log(item);
        });
    },
    getVariables() {
      const matches = this.plantillaEditar.texto.matchAll(/{{(.*?)}}/g);
      this.plantillaEditar.variables = [
        ...new Set(Array.from(matches, (x) => x[1])),
      ];
    },
    save() {
      let _vm = this;
      _vm.getVariables();
      _vm.loadingForm = true;
      this.$store
        .dispatch("contratos/savePlantilla", this.plantillaEditar)
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Plantilla guardada",
          });
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido guardar la plantilla " + e,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
          _vm.formDialog = false;
          _vm.reload();
        });
    },
    goEdit(item) {
      this.plantillaEditar = item;
      this.formDialog = true;
    },
    onEditorChange(event) {
      console.log(event);
      this.plantillaEditar.texto = event.html;
    },
    reiniciarCampos() {
      this.plantillaEditar = {
        id: null,
        texto: "",
        variables: [],
      };
    },
    addPlantilla() {
      this.formDialog = true;
    },
    view(item) {
      this.$router.push("/admin/facturacion/form/" + item.id);
    },
    goEliminar(item) {
      console.log(item);
      let _vm = this;
      var confirm = false;
      this.$confirm(
        "¿Desea eliminar la plantilla? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      )
        .then((r) => {
          if (r) {
            confirm = true;
            item.loadingEliminar = true;
            return this.$store.dispatch("contratos/eliminarPlantilla", item.id);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Plantilla eliminada",
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar la plantilla " + e,
          });
        })
        .finally(() => {
          item.loadingEliminar = false;
          _vm.reload();
        });
    },
    reload() {
      let _vm = this;
      _vm.loading = true;
      this.$store
        .dispatch("contratos/getPlantillas")
        .then(() => {})
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar las plantillas " + e,
          });
        })
        .finally(() => (_vm.loading = false));
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>
